import GeoQImageryProvider from './imagery/geoq/GeoQImageryProvider';
import BaiduImageryProvider from './imagery/baidu/BaiduImageryProvider';
import AmapImageryProvider from './imagery/amap/AmapImageryProvider';
import TencentImageryProvider from './imagery/tencent/TencentImageryProvider';
import TdtImageryProvider, {TdtLabelImageryProvider} from './imagery/tdt/TdtImageryProvider';
import JiangSuTdtImageryProvider from './imagery/tdt/JiangSuTdtImageryProvider';
import ShanDongTdtImageryProvider from './imagery/tdt/ShanDongTdtImageryProvider';
import GoogleImageryProvider from './imagery/google/GoogleImageryProvider';
import IRSImageryProvider, {IRSLabelImageryProvider} from './imagery/irs/IRSImageryProvider';

import img from '../../assets/base-img.png';
import img_1 from '../../assets/base-img-1.png';
import img_2 from '../../assets/base-img-2.png';
import img_3 from '../../assets/base-img-3.png';
import img_4 from '../../assets/base-img-4.png';
import img_5 from '../../assets/base-img-5.png';
import img_6 from '../../assets/base-img-6.png';
import EventEmitter from '../../_util/EventEmitter';

export const Imagery = {
    GeoQImageryProvider,
    AmapImageryProvider,
    BaiduImageryProvider,
    TencentImageryProvider,
    TdtImageryProvider,
    GoogleImageryProvider,
    IRSImageryProvider,
    JiangSuTdtImageryProvider,
    ShanDongTdtImageryProvider,
};

export const OPTIONS = [
    {
        label: '地图风格',
        value: 'GeoQImageryProvider',
        children: [
            { label: '蓝黑版', value: 'Blue', img: img_5 },
            { label: '彩色版', value: 'Community', img: img_2 },
            { label: '暖色版', value: 'StreetWarm', img: img_3 },
            { label: '灰色版', value: 'ChinaOnlineStreetGray', img: img_4 },
        ],
    },
    {
        label: '天地图',
        value: 'TdtImageryProvider',
        children: [
            { label: '影像图', value: 'img', img: img },
            { label: '矢量图', value: 'vec', img: img_1 },
            { label: '矢量图(暗色)', value: 'dark', img: img_6, style: 'dark' },
        ],
    },
    {
        label: '高德地图',
        value: 'AmapImageryProvider',
        children: [
            { label: '影像图', value: 'IMG', img: img },
            { label: '矢量图', value: 'ELEC', img: img_1 },
            { label: '矢量图(暗色)', value: 'dark', img: img_6 },
        ],
    },
    {
        label: '腾讯地图',
        value: 'TencentImageryProvider',
        children: [
            { label: '影像图', value: 'IMG', img: img },
            { label: '矢量图', value: 'ELEC', img: img_1 },
            { label: '矢量图(暗色)', value: 'dark', img: img_6 },
        ],
    },
    {
        label: '百度地图',
        value: 'BaiduImageryProvider',
        children: [
            { label: '影像图', value: 'IMG', img: img },
            { label: '矢量图', value: 'CUSTOM', img: img_1 },
            { label: '矢量图(暗色)', value: 'dark', img: img_6 },
        ],
    },
];

export class BaseMap extends EventEmitter {
    constructor(options) {
        super();

        this.map = options.map;

        this.options = options.options || OPTIONS;

        this.imageryProvider = options.imageryProvider || '';

        this.style = options.style || '';

        this.layer = options.layer || this.addLayer();
    }

    setBaseMap(options) {
        this.removeLayer(); // 删除老的底图

        const {imageryProvider, style, ...otherVal } = options;

        this.imageryProvider = imageryProvider;

        this.style = style;

        const ImageryProvider = Imagery[imageryProvider];
        const layer = new ImageryProvider({
            style,
            ...otherVal
        });

        this.map.imageryLayers.addImageryProvider(layer, 0);

        return layer
    }

    getValue() {
        const imageryProvider = this.imageryProvider;
        const style = this.style;
        const options = this.options;

        let value = {};
        options.map(v => {
            if (v.value === imageryProvider) {
                v.children.map(c => {
                    if (c.value === style) {
                        value = { ...c, value: `${v.value}_${c.value}` };
                    }
                });
            }
        });

        return value;
    }

    setValue(imageryProvider, style) {
        this.removeLayer(); // 删除老的底图

        this.imageryProvider = imageryProvider;

        this.style = style;

        this.layer = this.addLayer();
    }

    addLayer() {
        const map = this.map;
        const imageryProvider = this.imageryProvider;
        const style = this.style;
        const options = this.options;

        let layer;
        if (imageryProvider) {
            if (options?.length) {
                options.map(v => {
                    let { children, value } = v;
                    if (value === imageryProvider && Imagery[value]) {
                        let child = children.find(c => c.value === style);

                        const ImageryProvider = Imagery[value];
                        layer = new ImageryProvider({
                            style: child.value,
                            crs: 'WGS84',
                            dark: map.dark,
                            ...child
                        });
                        this.layer = map.imageryLayers.addImageryProvider(layer, 0);

                        // 调用影响中文注记服务
                        if (imageryProvider === 'TdtImageryProvider') {
                            let cia = new TdtLabelImageryProvider({
                                ...child
                            });
                            map.imageryLayers.addImageryProvider(cia, 1); // 添加到cesium图层上
                        } else if (imageryProvider === 'IRSImageryProvider') {
                            let cia = new IRSLabelImageryProvider({...child});
                            map.imageryLayers.addImageryProvider(cia, 1); // 添加到cesium图层上
                        }
                    }
                });
            }
        }

        return layer;
    }

    removeLayer() {
        const map = this.map;
        const layers = map.imageryLayers._layers;
        const removeLayers = [];
        layers.map(layer => {
            if (layer.imageryProvider) {
                if (
                    layer.imageryProvider instanceof GeoQImageryProvider ||
                    layer.imageryProvider instanceof AmapImageryProvider ||
                    layer.imageryProvider instanceof BaiduImageryProvider ||
                    layer.imageryProvider instanceof TencentImageryProvider ||
                    layer.imageryProvider instanceof TdtImageryProvider ||
                    layer.imageryProvider instanceof JiangSuTdtImageryProvider ||
                    layer.imageryProvider instanceof ShanDongTdtImageryProvider ||
                    layer.imageryProvider instanceof GoogleImageryProvider ||
                    layer.imageryProvider instanceof TdtLabelImageryProvider ||
                    layer.imageryProvider instanceof IRSLabelImageryProvider ||
                    layer.imageryProvider instanceof IRSImageryProvider
                ) {
                    removeLayers.push(layer);
                }
            }
        });

        removeLayers.map(layer => map.imageryLayers.remove(layer))
    }
}
